import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@sylva/shared-types/database';

export type ResourceRow = Tables<'resources'>;

export interface Resource {
  id: string;
  tenant_id: string;
  name: string;
  description: string;
  capacity: number;
  created_at: string;
  updated_at: string;
}

export const fetchResources = async (tenantId: string): Promise<Resource[]> => {
  const { data, error } = await supabase
    .from('resources')
    .select('*')
    .eq('tenant_id', tenantId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data || []) as Resource[];
};

export const createResource = async (
  tenantId: string,
  resource: Omit<Resource, 'id' | 'created_at' | 'updated_at' | 'tenant_id'>
): Promise<Resource> => {
  const { data, error } = await supabase
    .from('resources')
    .insert([{ ...resource, tenant_id: tenantId }])
    .select()
    .single();

  if (error) throw error;
  return data as Resource;
};

export const updateResource = async (
  id: string,
  updates: Partial<Omit<Resource, 'id' | 'created_at' | 'updated_at' | 'tenant_id'>>
): Promise<Resource> => {
  const { data, error } = await supabase
    .from('resources')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as Resource;
};

export const deleteResource = async (id: string): Promise<void> => {
  const { error } = await supabase
    .from('resources')
    .delete()
    .eq('id', id);

  if (error) throw error;
};